export enum League {
    PRO = "nfl",
    COLLEGE = "college-football",
}